/* Hidden Gems Club — cart drawer + AJAX add-to-cart */

(function () {
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  var overlay = qs('[data-cart-overlay]');
  var drawer = qs('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      closeDrawer();
    }
  });

  function renderCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshDrawer() {
    fetch('/cart?view=drawer')
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('[data-cart-drawer]');
        if (freshDrawer && drawer) {
          drawer.innerHTML = freshDrawer.innerHTML;
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-add-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding…';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add to cart failed');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        refreshDrawer();
        openDrawer();
      })
      .catch(function () {
        window.location.href = form.action || '/cart';
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || 'Add to Cart';
        }
      });
  });

  // Quantity / remove inside drawer (delegated, since drawer content refreshes)
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (qtyBtn) {
      var line = qtyBtn.getAttribute('data-line');
      var delta = parseInt(qtyBtn.getAttribute('data-cart-qty-change'), 10);
      var input = qs('[data-cart-qty-input="' + line + '"]');
      var current = input ? parseInt(input.value, 10) : 1;
      var next = Math.max(0, current + delta);
      updateLine(line, next);
    }

    if (removeBtn) {
      var removeLine = removeBtn.getAttribute('data-cart-remove');
      updateLine(removeLine, 0);
    }
  });

  function updateLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderCartCount(cart.item_count);
        refreshDrawer();
      });
  }
})();
